import { Form, Input, Select, Button, Card, Spin, DatePicker } from "antd";
import { UserService } from "../../services/user/UserService";
import { CfgUserService } from "../../services/cfgUser/CfgUserService";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import React, { Component } from "react";
import { showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./User.css";
import "./CreateUser.css";
import { Translation } from "react-i18next";
import i18next from "i18next";

import moment from "moment";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";

import { Constants } from "../../data/constants";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { HttpService } from "../../utils/HttpService";

dayjs.extend(customParseFormat);
class UpdateUserForm extends Component {
  userService = new UserService();
  accountGroupService = new AccountGroupService();

  constructor(props) {
    super(props);
    this.constants = new Constants();
    this.props.context.setCurrentComponent("editUsers");
    this.httpService = new HttpService();

    this.state = {
      validateStatus: "success",

      user: {},
      isFetching: false,
      formLayout: "inline",
      isFetchingCfg: false,
      allAgentStatus: [],
      agent_status: "",
      agentGroup: {},
      agentGroups: [],
      alluserTypes: [
        { value: "ADMIN", name: "Admin", nameAr: "مسئول" },
        { value: "AGENT", name: "Agent", nameAr: "موظف" },
      ],
      onlineAvailability: 0,
      agentCurrentStatus: "",
      lang:
        this.props.context.curr_lang === "ar" &&
        this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
    };
  }

  async componentDidMount() {
    await this.getUserData();
    try {
      this.setState({ isFetching: true });
      let allAgentStatus = await this.userService.getAllAgentStatusService(
        this.props.context.session_id
      );
      let addStatusArabic = allAgentStatus.ivrList;
      addStatusArabic.forEach((elem) => {
        if (elem.status == "ONLINE") elem.statusAr = "متصل";
        if (elem.status == "OFFLINE") elem.statusAr = "غير متصل";
        if (elem.status == "AUX") elem.statusAr = "عطل في الجهاز";
        if (elem.status == "BREAK") elem.statusAr = "استراحة";
      });
      this.setState({
        allAgentStatus: addStatusArabic,
        isFetching: false,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  async getUserData() {
    let { id } = this.props.match.params;
    let agent_status = "";
    let agentGroup = {};
    let agentCurrentStatus = "";
    try {
      this.acc = new UserService();

      this.setState({ isFetching: true });
      let user = await this.acc.getUserByIdService(
        this.props.context.session_id,
        id
      );
      if (user.ivrCustomEntityObject.cfg.length) {
        user.ivrCustomEntityObject.cfg.forEach((element) => {
          if (
            Object.getOwnPropertyNames(element).indexOf("AGENT_STATUS") > -1
          ) {
            agent_status = element["AGENT_STATUS"];
            agentCurrentStatus = element["AGENT_STATUS"];
          }
        });
      }
      if (user.ivrCustomEntityObject.userType === "AGENT") {
        let res = await this.acc.getUserGroup(
          this.props.context.session_id,
          id
        );
        agentGroup = res.ivrList.length > 0 ? res.ivrList[0] : {};
      }
      let agentGroups = await this.getAgentGroups();

      this.setState({
        user: user.ivrCustomEntityObject,
        isFetching: false,
        agent_status,
        agentGroup,
        agentCurrentStatus,
        agentGroups: agentGroups ? agentGroups.ivrList : [],
        onlineAvailability: agentGroups ? agentGroups.cfgList[0] : 0,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  async getAgentGroups() {
    try {
      let data = await this.accountGroupService.getAccountGroupsByType(
        this.props.context.session_id,
        this.constants.groupTypeList["SXG"]
      );
      return data;
    } catch (e) {
      handleError(e);
    }
  }
  handleDropdownChange(value) {
    if (value === "ADMIN") {
      this.setState({ IsAgent: false });
    } else if (value === "AGENT") {
      this.setState({ IsAgent: true });
    }
  }
  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          this.userService = new UserService();
          values["accountId"] = this.props.context.user.accountId;
          values["userId"] = this.props.match.params.id
            ? this.props.match.params.id
            : "";

          const selectedDate = values["userBirthdate"]
            .format("YYYY")
            .toString()
            .split("T")[0];
          const todaysDate = dayjs()
            .endOf("day")
            .format("YYYY")
            .toString()
            .split("T")[0];
          if (todaysDate - selectedDate >= 18) {
            values["userBirthdate"] = values["userBirthdate"]
              .format()
              .toString()
              .split("T")[0];
          } else {
            throw new Error(i18next.t("user age must be at least 18"));
          }
          values["userStatus"] = this.state.user.userStatus;
          if (this.state.user.userType === "AGENT" || this.state.IsAgent) {
            values["cfg"] = [
              {
                key: "AGENT_NUMBER",
                value:
                  this.props.context.user.userNumberType !== "alphanumeric" ||
                  this.state.user.userType === "ADMIN"
                    ? values["userNumber"]
                    : values["userNumberA"],
                configCategory: "CTI",
              },
              {
                key: "AGENT_STATUS",
                value: values["cfgUserStatus"],
                configCategory: "CTI",
              },
            ];
            if (values["agentGroup"]) {
              if (this.state.agentGroup.groupId !== values["agentGroup"]) {
                try {
                  // if (Object.keys(this.state.agentGroup).length != 0) {
                  //   let data = await this.userService.deleteUserFromGroup(
                  //     this.props.context.session_id,
                  //     this.state.agentGroup.groupId,
                  //     values["userId"]
                  //   );

                  //   if (data.statusCode == 0) {
                  //     await this.userService.assignUserGroup(
                  //       this.props.context.session_id,
                  //       values["agentGroup"],
                  //       values["userId"]
                  //     );
                  //   }
                  // } else {
                    await this.userService.assignUserGroup(
                      this.props.context.session_id,
                      values["agentGroup"],
                      values["userId"]
                    );
                  //}
                } catch (e) {
                  handleError(e);
                }
              }
            }
          } else {
            values["cfg"] = [];
          }
          values["userNumber"] =
            this.props.context.user.userNumberType !== "alphanumeric" ||
            this.state.user.userType === "ADMIN"
              ? values["userNumber"]
              : values["userNumberA"];
          values["agentCurrentStatus"] = this.state.agentCurrentStatus;
          let data = await this.userService.editUser(
            this.props.context.session_id,
            values
          );

          if (
            this.state.agent_status !== values["cfgUserStatus"] &&
            this.state.user.userType !== "ADMIN"
          ) {
            let agentChangeStatus = {
              agentId: this.state.user.userId,
              accountId: this.props.context.user.accountId,
              fromState: this.state.agent_status,
              toState: values["cfgUserStatus"],
              changedBy: this.props.context.user.userId,
            };
            let response = await this.userService.changeAgentStatus(
              this.props.context.session_id,
              agentChangeStatus
            );
          }
          showSuccessToast(i18next.t(data.statusMsg));
          this.setState({ loading: false });

          this.props.form.resetFields();
          history.push("/home/users/");
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  handleStatusChange(value) {
    let { user } = this.state;
    user.userStatus = value;
    this.setState({ user });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const { Option } = Select;
    let {
      isFetching,
      isFetchingCfg,
      allAgentStatus,
      agent_status,
      agentGroups,
      agentGroup,
      alluserTypes,
      onlineAvailability,
    } = this.state;
    const agentStatusOptions = allAgentStatus.map((opt) => (
      <Option
        key={opt.status}
        value={opt.status}
        // disabled={
        //   onlineAvailability <= 0 && opt.status === "ONLINE" ? true : false
        // }
      >
        {this.state.lang == "ar" ? opt.statusAr : opt.statusDescription}
      </Option>
    ));

    const agentGroupsOptions = agentGroups.map((opt) => (
      <Option key={opt.groupId} value={opt.groupId}>
        {opt.groupName}
      </Option>
    ));
    const userTypesOptions = alluserTypes.map((opt) => (
      <Option key={opt.value} value={opt.value}>
        {this.state.lang === "ar" ? opt.nameAr : opt.name}
      </Option>
    ));
    const disabledDate = (current) => {
      // Can not select days after today
      return current > dayjs().endOf("day");
    };
    return (
      <Translation>
        {(t) => (
          <Page title={t("Update User")} hasBackArrow={true}>
            {isFetching || isFetchingCfg ? (
              <Spin></Spin>
            ) : (
              <Card
                style={{
                  marginTop: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                }}
                bordered={false}
              >
                <Form className="form-style" {...formItemLayout}>
                  <Form.Item label={t("Email")} {...formItemLayout}>
                    {getFieldDecorator("userEmail", {
                      initialValue: this.state.user.userEmail,
                      rules: [
                        {
                          type: "email",
                          message: t("The input is not valid E-mail!"),
                        },
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user email"),
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>

                  <Form.Item label={t("Full Name")} {...formItemLayout}>
                    {getFieldDecorator(
                      "userFullname",

                      {
                        initialValue: this.state.user.userFullname,

                        rules: [
                          {
                            type: "string",
                            message: t("The input is not valid "),
                          },
                          {
                            required: true,
                            message: t("Please enter user full name"),
                          },
                        ],
                      }
                    )(<Input />)}
                  </Form.Item>

                  <Form.Item label={t("Birthdate")} {...formItemLayout}>
                    {getFieldDecorator("userBirthdate", {
                      initialValue: moment(
                        this.state.user.userBirthdate,
                        "YYYY-MM-DD"
                      ),
                      rules: [
                        {
                          required: true,
                          message: t("Please enter user birthdate"),
                        },
                      ],
                    })(
                      <DatePicker
                        disabledDate={disabledDate}
                        locale={this.state.lang === "ar" ? ar : en}
                      />
                    )}
                  </Form.Item>

                  <Form.Item label={t("Gender")} {...formItemLayout}>
                    {getFieldDecorator("userGender", {
                      initialValue: this.state.user.userGender,
                      rules: [
                        {
                          required: true,
                          message: t("Please select user gender"),
                        },
                      ],
                    })(
                      <Select
                        placeholder={t("Select ")}
                        onChange={this.handleSelectChange}
                      >
                        <Option value="M">{t("Male")}</Option>
                        <Option value="F">{t("Female")}</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item label={t("User Name")} {...formItemLayout}>
                    {getFieldDecorator("userName", {
                      initialValue: this.state.user.userName,
                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user name"),
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>

                  <Form.Item
                    style={{
                      display:
                        this.props.context.user.userNumberType ===
                          "alphanumeric" && this.state.user.userType !== "ADMIN"
                          ? "block"
                          : "none",
                    }}
                    label={t("Mobile Number")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator("userNumberA", {
                      initialValue:
                        this.props.context.user.userNumberType ===
                          "alphanumeric" && this.state.user.userType !== "ADMIN"
                          ? this.state.user.userNumber
                          : "",
                      rules: [
                        {
                          type: "string",
                          message: t("Mobile number is not valid "),
                          pattern: "^[a-zA-Z0-9_@$.*]*$",
                        },
                        {
                          required:
                            this.props.context.user.userNumberType ===
                              "alphanumeric" &&
                            this.state.user.userType !== "ADMIN"
                              ? true
                              : false,
                          message: t("Please enter mobile number"),
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>

                  <Form.Item
                    style={{
                      display:
                        this.props.context.user.userNumberType !==
                          "alphanumeric" || this.state.user.userType === "ADMIN"
                          ? "block"
                          : "none",
                    }}
                    label={t("Mobile Number")}
                    {...formItemLayout}
                    validateStatus={this.state.validateStatus}
                    help={
                      this.state.validateStatus == "error"
                        ? "Mobile number is not valid"
                        : ""
                    }
                    hasFeedback={this.state.validateStatus}
                  >
                    {getFieldDecorator("userNumber", {
                      initialValue:
                        this.props.context.user.userNumberType !==
                          "alphanumeric" || this.state.user.userType === "ADMIN"
                          ? this.state.user.userNumber
                          : "",
                      rules: [
                        {
                          type: "string",
                          message: t("Mobile number is not valid "),
                          min: 12,
                          max: 12,
                          pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                        },
                        {
                          required:
                            this.props.context.user.userNumberType !==
                              "alphanumeric" ||
                            this.state.user.userType === "ADMIN"
                              ? true
                              : false,
                          message: t("Please enter mobile number"),
                        },
                      ],
                    })(
                      <Input
                        maxLength={12}
                        placeholder="201XXXXXXXXX"
                        onChange={ async(e) => {
                          if (
                            !/^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$/.test(
                              e.target.value
                            ) ||
                            e.target.value.length < 12
                          ) {
                            this.setState({ validateStatus: "error" });
                            return;
                          }
                          if(!this.constants.TESTING){

                          if (e.target.value.length == 12) {
                            this.setState({ validateStatus: "validating" });
                            let response =  await this.userService.validateUserNumber(this.props.context.session_id,e.target.value)

                            if (response == null) {
                              this.setState({ validateStatus: "error" });
                            } else {
                              if (response.exceptionCode == 0 || response.exceptionCode=="0") {
                                this.setState({ validateStatus: "success" });
                              } else {
                                this.setState({ validateStatus: "error" });
                              }
                            }
                          }
                        }else{
                          this.setState({ validateStatus: "success" });

                        }
                        }}
                      />
                    )}
                  </Form.Item>
                  {/* <Form.Item label="Number" {...formItemLayout}>
                {getFieldDecorator("userNumber", {
                  initialValue: this.state.user.userNumber,
                  rules: [
                    {
                      type: "string",
                      message: "The input is not valid "
                    },
                    {
                      required: true,
                      message: "Please enter user number"
                    }
                  ]
                })(<Input maxLength={11}/>)}
              </Form.Item> */}
                  <Form.Item label={t("Type")} {...formItemLayout}>
                    {getFieldDecorator("userType", {
                      initialValue: this.state.user.userType,
                    })(
                      <Select
                        // style={{ width: "100%" }}
                        style={{
                          width: "100%",
                          display:
                            this.state.user.userType == "ADMIN"
                              ? "block"
                              : "none",
                        }}
                        onChange={(value) => {
                          this.handleDropdownChange(value);
                        }}
                      >
                        {userTypesOptions}
                      </Select>
                    )}
                    <label
                      style={{
                        display:
                          this.state.user.userType == "AGENT"
                            ? "block"
                            : "none",
                      }}
                    >
                      {t(this.state.user.userType)}{" "}
                    </label>
                  </Form.Item>
                  <Form.Item
                    style={{
                      display:
                        this.state.user.userType !== "ADMIN" ||
                        this.state.IsAgent
                          ? "block"
                          : "none",
                    }}
                    label={t("Status")}
                    {...formItemLayout}
                  >
                    {getFieldDecorator("cfgUserStatus", {
                      initialValue: agent_status
                        ? agent_status
                        : onlineAvailability > 0
                        ? "ONLINE"
                        : "OFFLINE",
                      rules: [
                        {
                          required:
                            this.state.user.userType !== "ADMIN" ? true : false,
                          message: t("Please select user status"),
                        },
                      ],
                    })(<Select>{agentStatusOptions}</Select>)}
                  </Form.Item>
                  <Form.Item
                    label={t("Group")}
                    {...formItemLayout}
                    style={{
                      display:
                        this.state.user.userType !== "ADMIN" ||
                        this.state.IsAgent
                          ? "block"
                          : "none",
                    }}
                  >
                    {getFieldDecorator("agentGroup", {
                      initialValue: agentGroup.groupId,

                      rules: [
                        {
                          message: t("Please select agent group"),
                        },
                      ],
                    })(
                      <Select style={{ width: "100%" }}>
                        {agentGroupsOptions}
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      xs: { span: 24, offset: 0 },
                      sm: { span: 16, offset: 8 },
                    }}
                  >
                    <Button
                      className="button-submit"
                      type="primary"
                      onClick={this.handleConfirm}
                      size={"small"}
                      loading={this.state.loading}
                      disabled={this.state.validateStatus != "success"}
                    >
                      {t("Submit")}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(UpdateUserForm))
);
